import {
  PhoneNumberFormat as PNF,
  PhoneNumberUtil,
} from 'google-libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();
const { ValidationResult } = PhoneNumberUtil;

const getExampleNumber = (regionCode: string) =>
  phoneUtil.format(phoneUtil.getExampleNumber(regionCode), PNF.E164);

const validateNumber = (number: string, regionCode = 'AU') => {
  try {
    const pNumber = phoneUtil.parse(number, regionCode);
    return phoneUtil.isPossibleNumberWithReason(pNumber);
  } catch (e: any) {
    if (e.message === 'The string supplied is too long to be a phone number') {
      return ValidationResult.TOO_LONG;
    }
    return ValidationResult.INVALID_LENGTH; // Catch all response
  }
};

const getValidationText = (value: PhoneNumberUtil.ValidationResult) => {
  switch (value) {
    case ValidationResult.IS_POSSIBLE:
      return '';

    case ValidationResult.TOO_SHORT:
      return 'The phone number is too short. Please try again.';

    case ValidationResult.TOO_LONG:
      return 'The phone number is too long. Please try again.';

    case ValidationResult.INVALID_COUNTRY_CODE:
    case ValidationResult.IS_POSSIBLE_LOCAL_ONLY:
    case ValidationResult.INVALID_LENGTH:
    default:
      return 'The phone number seems to be invalid. Please try again.';
  }
};

export {
  getExampleNumber,
  getValidationText,
  validateNumber,
  ValidationResult,
};
